import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import SwipeableViews from 'react-swipeable-views';
import Scrollbars from '../../components/utility/customScrollBar';
import Tabs, { Tab } from '../../components/uielements/tabs';
import TopbarMessage from './topbarMessage';
import TopbarNotifications from './topbarNotifications';
import { SidebarContent, Icon, CloseButton } from './sidebarNotification.style';
import themeActions from '../../redux/themeSwitcher/actions';
import { Dot } from './style';
const { switchActivation } = themeActions;

const theme = createMuiTheme({
	overrides: {
		MuiTab: {
			root: {
				minWidth: 'auto !important',
				color: '#ffffff',
			},
			labelContainer: {
				padding: '6px 5px !important',
			},
			label: {
				fontSize: 13,
			},
		},
		MuiTabs: {
			root: {
				backgroundColor: '#3b4448',
				paddingTop: 18,
			},
			indicator: {
				backgroundColor: '#00b6f9',
			}
		},
		MuiBadge: {
			badge: {
				width: 7,
				height: 7,
				marginTop: 7,
				marginRight: 11,
			}
		}
	},
});


const TabContainer = ({ children, dir }) => {
	return <div>{children}</div>;
};
class SidebarNotification extends Component {
	state = {
		visible: false,
		anchorEl: null,
		tabValue: 0,
	};
	hide = () => {
		this.setState({ visible: false });
	};
	handleVisibleChange = () => {
		this.setState({
			visible: !this.state.visible,
			anchorEl: findDOMNode(this.notificationbutton),
		});
	};
	handleTabChanged = (event, tabValue) => {
		this.setState({ tabValue });
	};
	handleChangeIndex = tabValue => {
		this.setState({ tabValue });
	};
	render() {
		const {
			locale,
			url,
			switchActivation,
			unactionedNotifications,
			actionedNotifications,
			totalActioned,
			totalUnactioned,
			loadActioned,
			loadUnactioned,
			loadingActioned,
			loadingUnactioned,
			loadingNotifications,
			compulsoryNotifications,
			totalCompulsory,
			loadingCompulsory,
			loadCompulsory,
			loadingMoreCompulsory,
		} = this.props;
		const propsTopbar = { locale, url };
		return (
			<div>
				<CloseButton onClick={() => switchActivation(false)}>
					<Icon>close</Icon>
				</CloseButton>

				<MuiThemeProvider theme={theme}>
					<Tabs
						value={this.state.tabValue}
						onChange={this.handleTabChanged}
						indicatorColor="secondary"
						textColor="inherit"
						fullWidth
					>
						<Tab style={{ height: 48 }} label={`Urgent notifications`} icon={<Dot color="secondary" variant="dot" invisible={!(totalCompulsory > 0)} />} />
						<Tab style={{ height: 48 }} label={`All notifications`} icon={<Dot color="secondary" variant="dot" invisible={!(totalUnactioned > 0)} />} />
					</Tabs>
				</MuiThemeProvider>

				<SwipeableViews
					axis={'x'}
					index={this.state.tabValue}
					onChangeIndex={this.handleChangeIndex}
				>
					<TabContainer>
						<TopbarNotifications
							topTitle="Urgent"
							topNotifications={compulsoryNotifications}
							totalTop={totalCompulsory}
							loadTop={loadCompulsory}
							loadingTop={loadingMoreCompulsory}
							loadingNotifications={loadingCompulsory}
							closeDrawer={() => switchActivation(false)}
						/>
					</TabContainer>
					<TabContainer>
						<TopbarNotifications
							topTitle="Pending"
							topNotifications={unactionedNotifications}
							totalTop={totalUnactioned}
							loadTop={loadUnactioned}
							loadingTop={loadingUnactioned}
							bottomTitle="Completed"
							bottomNotifications={actionedNotifications}
							totalBottom={totalActioned}
							loadBottom={loadActioned}
							loadingBottom={loadingActioned}
							loadingNotifications={loadingNotifications}
							closeDrawer={() => switchActivation(false)}
						/>
					</TabContainer>
				</SwipeableViews>
			</div>
		);
	}
} 

export default connect(
	state => ({
		...state.App,
		customizedTheme: state.ThemeSwitcher.topbarTheme,
		height: state.App.height,
	}),
	{ switchActivation }
)(SidebarNotification);



// WEBPACK FOOTER //
// ./src/containers/Topbar/sidebarNotification.js